import type { ModalConfig } from "./types";

export const employeeModalsModalUrlConfig = {
  // Employee Modals
  "employees-detail": {
    modalId: "employees-detail",
    entityName: "employees",
    singularParam: "employeeId",
    pluralParam: "employeesId",
    displayName: "Employee",
  },
  "create-employees": {
    modalId: "create-employees",
    entityName: "employees",
    singularParam: "employeeId",
    pluralParam: "employeesId",
    displayName: "Employee",
  },
  "edit-employees": {
    modalId: "edit-employees",
    entityName: "employees",
    singularParam: "employeeId",
    pluralParam: "employeesId",
    displayName: "Employee",
  },
} as const satisfies Record<string, ModalConfig>;
